import { Controller } from "@hotwired/stimulus";

/**
 * ページを開いたときにアプリのストアレビュー訴求を呼び出す。
 * 表示可否や回数制限の判定はアプリ側にあるため、sion-web はタイミングに合わせて呼ぶだけ。
 * data-controller="request-store-review"
 */
export default class extends Controller {
  connect() {
    // アプリ (window.MobilicoApp) がすでに読み込まれていれば即呼ぶ (Turbo 遷移時など)。
    this.#requestReview();
    // まだ読み込まれていない場合に備えて、読み込み完了イベントでも呼ぶ。
    document.addEventListener("MobilicoAppLoaded", this.#requestReview);
  }

  disconnect() {
    document.removeEventListener("MobilicoAppLoaded", this.#requestReview);
  }

  #requested = false;

  #requestReview = () => {
    if (this.#requested) return;
    // requestStoreReview がないバージョンのアプリでは何もしない。
    if (!window.MobilicoApp?.requestStoreReview) return;

    window.MobilicoApp.requestStoreReview();
    this.#requested = true;
  };
}
